/* eslint-disable no-redeclare */
import { z } from 'zod';

export const Placement = z.enum([
  'LANDING',
  'EMAIL',
  'SURVEY',
  'TYP',
  'QUOTES',
  'FAS',
  'FEEDBACK',
  'TYP_FOOTER',
]);

export type Placement = z.infer<typeof Placement>;
